<section class="content-layout h-full">
  <header class="task-template__header px-10 py-8">
    <!-- Title & Breadcrumb -->
    <div class="title">
      <div class="breadcrumb mb-1">
        <span class="path">
          <a [routerLink]="['../']">Task List Templates</a>
          <span class="separator">/</span>
          Edit
        </span>
      </div>
      <h1 class="m-0">{{ taskListTemplate?.name }}</h1>
    </div>

    <div class="main-actions">
      <ng-container *ngIf="isGeneralInfoTabActive()">
        <button
          mat-flat-button
          [color]="'primary'"
          (click)="saveGeneralInfo()"
          [disabled]="taskListTemplateForm.pristine || taskListTemplateForm.invalid"
          data-testid="save-general-info-button"
        >
          <mat-icon [svgIcon]="'save'"></mat-icon>
          Save
        </button>
        <button class="more-menu ml-2" mat-icon-button [matMenuTriggerFor]="moreMenu" data-testid="more-menu-button">
          <mat-icon [svgIcon]="'more_vert'"></mat-icon>
        </button>
        <mat-menu #moreMenu="matMenu">
          <button mat-menu-item (click)="deleteTaskTemplate()" data-testid="delete-template-button">
            <mat-icon [svgIcon]="'delete'"></mat-icon>
            <span>Delete</span>
          </button>
        </mat-menu>
      </ng-container>

      <ng-container *ngIf="!isGeneralInfoTabActive()">
        <button class="more-menu" mat-icon-button [matMenuTriggerFor]="moreMenu" data-testid="config-more-menu-button">
          <mat-icon [svgIcon]="'more_vert'"></mat-icon>
        </button>
        <mat-menu #moreMenu="matMenu">
          <button
            mat-menu-item
            [matTooltip]="'Download as CSV'"
            [matTooltipPosition]="'above'"
            (click)="downloadTasks('pdf')"
            data-testid="download-pdf-button"
          >
            <mat-icon>save_alt</mat-icon>
            <span>Download PDF</span>
          </button>
          <button
            mat-menu-item
            [matTooltip]="'Download as CSV'"
            [matTooltipPosition]="'above'"
            (click)="downloadTasks('csv')"
            data-testid="download-csv-button"
          >
            <mat-icon>save_alt</mat-icon>
            <span>Download CSV</span>
          </button>
          <button mat-menu-item (click)="saveAsTemplate()" data-testid="save-as-template-button">
            <mat-icon [svgIcon]="'ts_save'"></mat-icon>
            <span>Save as Template</span>
          </button>

          @if (!taskCustomFieldsEnabled) {
            <button mat-menu-item (click)="updateExistingTaskLists()" data-testid="update-existing-lists-button">
              <mat-icon [svgIcon]="'ts_refresh'"></mat-icon>
              <span>Update Existing Lists</span>
            </button>
          }
        </mat-menu>
      </ng-container>
    </div>
  </header>

  <nav mat-tab-nav-bar [tabPanel]="tabPanel">
    <a mat-tab-link (click)="tabChange('info')" [active]="activeTab === 'info'" data-testid="tab-general-info">
      General Info
    </a>
    <a
      mat-tab-link
      (click)="tabChange('configuration')"
      [active]="activeTab === 'configuration'"
      data-testid="tab-configuration"
      >Configuration</a
    >
  </nav>
  <mat-tab-nav-panel #tabPanel>
    @if (activeTab === 'info') {
      <form [formGroup]="taskListTemplateForm">
        <div class="flex flex-col p-8 bg-card shadow overflow-hidden">
          <p class="text-lg font-medium">Template Name</p>
          <p class="text-secondary">Set the name of the template</p>
          <mat-divider
            role="separator"
            class="mat-divider mt-6 mb-4 mat-divider-horizontal"
            aria-orientation="horizontal"
          ></mat-divider>

          <div class="flex-auto min-w-64">
            <!-- Template Name -->
            <div class="flex flex-col gt-xs:flex-row mt-3">
              <mat-form-field class="subject flex-auto">
                <mat-label>Template Name</mat-label>
                <input matInput [formControlName]="'name'" data-testid="edit-template-name-input" />
              </mat-form-field>
            </div>

            <div class="flex flex-col gt-xs:flex-row mt-3">
              <mat-form-field class="subject flex-auto">
                <mat-label>Internal Value</mat-label>
                <input matInput [formControlName]="'internal_value'" data-testid="internal-value-input" />
              </mat-form-field>
            </div>

            <!-- Template Associated Layouts -->
            <div class="flex flex-col gt-xs:flex-row mt-3">
              <mat-form-field class="treo-mat-textarea treo-mat-no-subscript flex-auto">
                <mat-label>Associated Layouts</mat-label>
                <mat-select
                  [formControlName]="'associated_project_template_ids'"
                  multiple
                  data-testid="associated-layouts-select"
                >
                  <mat-option
                    *ngFor="let projectTemplate of projectTemplates"
                    [value]="projectTemplate.id"
                    [attr.data-testid]="'associated-layout-option-' + projectTemplate.id"
                  >
                    {{ projectTemplate.name }} ({{ getRelatedToTypeLabel(projectTemplate.related_to_type) }})
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </form>
    } @else {
      <router-outlet></router-outlet>
    }
  </mat-tab-nav-panel>
</section>

<ng-template #LoadingOrNoTasks>
  <ng-template #Loading>
    <div class="ph-item p-2">
      <div class="ph-col-12 p-0">
        <div class="ph-row">
          <div class="ph-col-12 big h-8 rounded"></div>
          <div class="ph-col-12 big h-6 rounded"></div>
          <div class="ph-col-12 big h-6 rounded"></div>
          <div class="ph-col-12 big h-8 rounded"></div>
          <div class="ph-col-12 big h-6 rounded"></div>
          <div class="ph-col-12 big h-6 rounded"></div>
          <div class="ph-col-12 big h-8 rounded"></div>
          <div class="ph-col-12 big h-6 rounded"></div>
          <div class="ph-col-12 big h-6 rounded"></div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-container *ngIf="tasks?.length === 0 && !isTaskListLoading; else Loading">
    <div class="no-tasks">
      <mat-icon [svgIcon]="'iconsmind:bulleted_list'"></mat-icon>
      <h4>Add a task to start planning!</h4>
    </div>
  </ng-container>
</ng-template>
